/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Events.Overview <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 22.1.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 29.1.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.EventOverview", $.common.VisualBase, {
    eventid: -1,
    eventType: 0,
    wizard: null,
    wizardStep: 0,
   visualType: "",
    dirty: false,
    vcV: new vcVisual(),
    alarmChannels: null,
    entryList: null,
    maxWidthForForms:1350,
    _create: function () {
        var me = this;

        try {
            // set the Visual-Name first
            me.options.invoke.vcvid = 308;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
          
            me.showMessage("", false);

            ////adopt heights and widths
            var h = parseInt(me.visual.height() -
                me.fnd("#div-event-selection").height() -
                me.fnd("#div-wizard").height());

            me.fnd("#div-list").height(h);
            me.fnd("#div-content,#div-config").height(h - 60);
            me.fnd("#div-list .vc-list-table").height(h - 110);

            //find the initial config status for the config tab
            me._getConfigStatus();
         

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            //init event listener
            _VCMQ.addConsumer(me.vcgid);
            _VCMQ.consume(me.visual, me.vcgid, function (event) { me._doEvent(event) });


            //init event type selection
            me.element.on("click", "#div-event-selection .button-toggle", function() {
                _VCMQ.produce(me.visual, me.vcgid, 'SELECT_EVENT_TYPE', $(this));
            });

            //init first type
            _VCMQ.produce(me.visual, me.vcgid, 'SELECT_EVENT_TYPE', me.fnd("#div-event-selection .button-toggle:first"));
           

            //init wizard
            me.wizard = me.fnd("#div-wizard").vcWizard({ 'stepWidth': 153 });

            me.element.on("click", "#div-wizard .vc-wizard-step", function () {
                if (!$(this).hasClass("inactive")) {
                    _VCMQ.produce(me.visual, me.vcgid, 'SELECT_EVENT_STEP', $(this));
                }
            });

            me.fnd("#btn-new").button();
            me.element.on("click", "#div-list #btn-new", function() {
                _VCMQ.produce(me.visual, me.vcgid, 'SELECT_EVENTID', { id:0, name:me.specific.resources.newEntry_lbl });
            });

            //init the list click handler
            me.fnd("#div-list .vc-list-table").on("click", '.vc-list-item', function (e) {
                if (!isNaN($(e.target).parents(".vc-list-item").data("id"))) {
                    var item = {
                        id: parseInt($(e.target).parents(".vc-list-item").data("id")),
                        name: $(e.target).parents(".vc-list-item").data("name")
                    }
                    _VCMQ.produce(me.visual, me.vcgid, 'SELECT_EVENTID', item);
                }
            });



            //click handler for the del and add buttons
            me.fnd("#div-list .vc-list-table").on("click", '.btn-test', function (e) {
                var id = parseInt($(e.target).parents(".vc-list-item").data("id"));
                me.openAskDialog(me.specific.resources.shouldSendTest_lbl + '<br/><br/>' + me.specific.resources.waitWillTakeAWhile_lbl, { at: 'center center-30%', of: window }, function () {
                    me._sendTask(id, 2); return true;
                }, function () { });
                e.stopPropagation();
            });


            //click handler for the del and add buttons
            me.fnd("#div-list .vc-list-table").on("click", '.btn-reset-status', function (e) {
                var id = parseInt($(e.target).parents(".vc-list-item").data("id"));
                me.openAskDialog(me.specific.resources.shouldSendReset_lbl, { at: 'center center-30%', of: window }, function () {
                    me._sendTask(id, 3);  return true;
                }, function () { });
                e.stopPropagation();
            });


            //click handler for the del and add buttons
            me.fnd("#div-list .vc-list-table").on("click", '.btn-del',function(e) {
                var id = parseInt($(e.target).parents(".vc-list-item").data("id"));
                me.openAskDialog(me.specific.resources.shouldEntryBeDeleted_lbl, { at: 'center center-30%', of: window }, function() {
                    me._del(id); return true;
                }, function () {});
                e.stopPropagation();
            });


        } catch (ex) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },

   _doEvent: function (event) {
        /// <summary>
        /// Handles differet internal and external events
        /// </summary>
        var me = this;
       try {


          //console.info("got event: " + event.msg);
          // console.info(event.values);

            switch (event.msg) {
                case 'SELECT_EVENT_TYPE': //switches between the different alarm/event types (or the config tab)
                    me._selectType(event.values);
                    break;
                case 'SELECT_EVENT_STEP': //switches between the different wizard steps
                    me._selectStep(event.values);
                    break;
                    
                case 'SELECT_EVENTID': //selects and event/alarm id
                    //when we get a saved event id we just load the first step again
                    me.eventid = parseInt(event.values.id);
                    me.fnd("#div-event-name").html(event.values.name);
                    me._selectStep(me.fnd("#div-wizard .vc-wizard-step[data-type='edit']"));
                    break;
                case 'SAVE_EVENTID': //selects and event/alarm id
                    //when we get a saved event id we just load the first step again and ...
                    me.eventid = parseInt(event.values);
                    me._selectStep(me.fnd("#div-wizard .vc-wizard-step[data-type='edit']"));
                    //.. we set the config dirty for all but archive alarms
                    if (me.eventType !== 2) {
                        _VCMQ.produce(me.visual, me.vcgid, 'EVENT_CONFIG_DIRTY', "");
                    }
                    break;
                case 'EVENT_CONFIG_DIRTY': //sets the config dirty state
                    me._getConfigStatus();
                    _VCMQ.produce(me.visual, me.vcgid, 'UNIT_REFRESH', "");
                    break;
                case 'UNIT_COMMITTED': //resets the config state after a sucessfully committed unit
                    me._getConfigStatus();

            default: break;
            }
        } catch (ex) { me.writeError('doEvent', ex); }
    },



    _selectType: function (obj) {
        /// <summary>
        /// This function switches between the  different alarm/event types (or the config tab)
        /// </summary>
        var me = this;
        var id;
        try {
          
            id= parseInt(obj.data("type"));

            if (id > 0) {
                me.eventType = id;
                me.fnd("#div-event-selection .button-toggle").removeClass("button-toggle-active");
                obj.addClass("button-toggle-active");
                //we init the correct wizard steps and load the list
                me._initWizard();
               
            } else {
                //if the id < 1 then we selected the config tab
                //we have to handle the overlay config config feature separately
                //this should change nothing on the current selection
                if (obj.hasClass("button-toggle-active")) {
                    obj.removeClass("button-toggle-active");
                    me.fnd("#div-config").html("").hide();
                    me.fnd("#div-content,#div-list, #div-wizard").removeClass("hide");
                } else {
                    obj.addClass("button-toggle-active");
                    me.fnd("#div-config").html(me.getLoadingIcon()).show();
                    me.fnd("#div-content,#div-list, #div-wizard").removeClass("hide").addClass("hide");
                    me.vcV.addVisualBaseByName('div-', "VISUAL_UNIT_CONFIGCOMMIT", "config", getCurrentTimestamp(), parseInt(me.fnd("#div-config").height()), parseInt(me.fnd("#div-config").width()), '', '', me.options.invoke.deviceType);
                }
            }
            return true;
        } catch (e) {
            me.writeError('_selectType', e); return false;
        }
    },

    _initWizard: function () {
        /// <summary>
        /// This function generates the wizard with the specific wizard steps based on the eventType
        /// </summary>
        var me = this;
        try {
           //first we clear every step
            me.wizard = me.fnd("#div-wizard").vcWizard({ 'stepWidth': 180 });
            for (var i = 0; i < me.fnd("#div-wizard .vc-wizard-step").length; i++) {
                me.wizard.vcWizard({ "clear": i });
            }
            me.fnd("#div-wizard .vc-wizard-step").show();
            me.fnd("#div-wizard").show();

            me.fnd("#div-wizard .vc-wizard-step[data-type='simulate']").hide();
            me.fnd("#div-wizard .vc-wizard-step[data-type='protocol']").hide();
            switch (me.eventType) {
                case 1: //system
                    me.fnd("#div-wizard .vc-wizard-step[data-type='rule']").hide();
                    me.fnd("#div-wizard .vc-wizard-step[data-type='channels']").hide();
                    me.fnd("#div-wizard .vc-wizard-step[data-type='timer']").hide();
                    break;
                case 2: //archive
                    me.fnd("#div-wizard .vc-wizard-step[data-type='channels']").hide();
                    break;
                case 3: //hr
                  //show all
                    break;
                case 4: //emax
                    me.fnd("#div-wizard .vc-wizard-step[data-type='user']").hide();
                    me.fnd("#div-wizard .vc-wizard-step[data-type='simulate']").show();
                    me.fnd("#div-wizard .vc-wizard-step[data-type='protocol']").show();
                    break;
                case -1: //config
                    me.fnd("#div-wizard").hide();
                    break;
                default:
            }
            //reset all selected steps and restart with the entry list 
            me._clearSteps();

            return true;
        } catch (e) {
            me.writeError('_initWizard', e); return false;
        }
    },



    _clearSteps: function () {
        /// <summary>
        /// This function resets everything when we clicked on a tab
        /// </summary>
        var me = this;
        try {

            me.wizardStep = 0;
            me.visualType = "list";
            me.eventid = -1;
       
            //we will start over - so we will show the entry list 
            me.fnd("#div-event-name").html("");
            me.fnd("#div-content, #div-config").removeClass("hide").hide();
            me.fnd("#div-list, #div-wizard").removeClass("hide").show();
          
            me._selectStep(me.fnd("#div-wizard .vc-wizard-step[data-type='list']"));

           

            return true;
        } catch (e) {
            me.writeError('_clearStep', e); return false;
        }
    },


    _selectStep: function (obj) {
        /// <summary>
        /// This function switches between the  different wizard steps
        /// </summary>
        var me = this;
        var i;
        try {
            me.wizardStep = parseInt(obj.data("step"));
            me.visualType = obj.data("type");
            //set the step to active
            me.wizard.vcWizard("setActive", me.wizardStep);

            //if we select the list wizard step - we reset the event id
            if (me.visualType === "list") {
                me.eventid = -1;
                me.fnd("#div-event-name").html("");
            }
          
            switch (me.eventid) {
                case -1: //we selected the list and have to deactivate all wizard steps for one single entry
                    for (i = 1; i < me.fnd("#div-wizard .vc-wizard-step").length; i++) {
                        me.fnd("#div-wizard .vc-wizard-step[data-step='" + i + "']").removeClass("inactive").addClass("inactive");
                    }
                    break;
                case 0: //if we want to add a new entry we have to deactivate all wizard steps except the edit step 
                    me.fnd("#div-wizard .vc-wizard-step[data-type='edit']").removeClass("inactive");
                    for (i = 2; i < me.fnd("#div-wizard .vc-wizard-step").length; i++) {
                        me.fnd("#div-wizard .vc-wizard-step[data-step='" + i + "']").removeClass("inactive").addClass("inactive");
                    }
                    break;
                default:
                    me.fnd("#div-wizard .vc-wizard-step").removeClass("inactive");
            }

            me._load();

            return true;
        } catch (e) {
            me.writeError('_selectType', e); return false;
        }
    },



    _load: function () {
        /// <summary>
        /// This function loads the specific content 
        /// </summary>
        var me = this;
        var h, w, w1;
        var id;
        try {

            var content = me.fnd("#div-content");

            //we hide the entry list (if it was eventually open)
            me.fnd("#div-config").hide();

            if (me.visualType === "list") {
                content.hide();
                me.fnd("#div-list").show();
            } else {
                me.fnd("#div-list").hide();
                content.show();
            }
            //we generate a new container
            w = parseInt(content.width());
            h = parseInt(content.height());

            me.container = me.getRandomIDContainerObj("div-content-", false);

            me.container.obj.height(h);
            me.container.obj.width(w);
            content.html(me.container.obj);
            me.container.obj.html(me.getLoadingIcon());



            if (me.eventType >= 0) {
                switch (me.visualType) {
                    case "list": //fetch the event list
                        me._fetch();
                        break;

                 case "edit"://show the event details
                        if (me.container.obj.width() > me.maxWidthForForms) {
                            w1 = me.maxWidthForForms;
                            me.container.obj.width(w1);
                        } else {
                            w1 = me.container.obj.width();
                        }
                    me.vcV.addVisualBaseByName('div-content-', "VISUAL_FORM_EVENT_DETAILS", me.container.random, getCurrentTimestamp(), h-20,w1,'true',
                        JSON.stringify({ "aid": me.eventid, "EventType": me.eventType }), me.options.invoke.deviceType);
                    break;

                case "rule"://show the event rule
                    me.vcV.addVisualBaseByName('div-content-',"VISUAL_ALARM_RULES_TEMPLATE", me.container.random, getCurrentTimestamp(), h, w, 'true',me.eventid,me.options.invoke.deviceType);
                    break;

                case "channels"://show the digital channels
                    me.container.obj.AlarmChannels({ invokeType: "addVisualBase",parameter: { aid: me.eventid, type: me.eventType - 3 } });
                    break;

                    case "timer"://show the timers
                    me.container.obj.EventTimer({ invokeType: "addVisualBase", parameter: { aid: me.eventid, eventType: me.eventType } });
                    break;

                    case "user":// user list
                        if (me.container.obj.width() > me.maxWidthForForms) {
                            w1 = me.maxWidthForForms;
                            me.container.obj.width(w1);
                        } else {
                            w1 = me.container.obj.width();
                        }
                    me.vcV.addVisualBaseByName('div-content-', "VISUAL_FORM_ALARMUSER",me.container.random, getCurrentTimestamp(), h-20, w1,'true', me.eventid,me.options.invoke.deviceType);
                    break;
                    //
                    case "history": //alarm history
                        id = me.eventid;
                        if (me.eventid === -1) { id = 99999999; }
                        me.vcV.addVisualBaseByName("div-content-", "VISUAL_ALARMHISTORY", me.container.random, getCurrentTimestamp(), h, w, JSON.stringify({ 'FixedContentHeight': true, aid: [id] }), "", me.settings.deviceType);
                        break;
                case "simulate":
                        me.container.obj.EmaxSimulate({ invokeType: "addVisualBase", parameter: { aid: me.eventid } });
                        break;

                    case "protocol":
                    
                        me.vcV.addVisualBaseByName('div-content-', "VISUAL_UNIT_HISTORY", me.container.random, getCurrentTimestamp(), h, w, JSON.stringify({ filterAlarmId: me.eventid , filtertype:3, startdate:'1.11.2022', enddate:'25.11.2022'}), '', me.options.invoke.deviceType);
                        break;

                    default: break;
                }
            }


        } catch (e) {
            me.writeError('_load', e); ;
        }
    },


    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {
           
            me.fnd("#div-list .vc-list-table").html(me.getLoadingIcon());
            var param = {eventType: me.eventType, type:1}
            me.getData(param, function (result) {
                //check response content
                if (result === null) {
                    me.entryList = null;
                } else {
                    me.entryList = result;
                    me._generateList();
                }
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false; }
        return true;
    },



    _generateList: function () {
        /// <summary>
        /// This function generates a list from the data and ...
        /// handles some specific for emax at the end
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item, col1, col2;
        var list;
        var tmp;
        var infoOk;
        var infoNotOk;
        try {

            me.fnd("#btn-new").show();
            list = me.fnd("#div-list .vc-list-table");
            if (me.entryList === null) {
                list.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            if (me.entryList.length === 0) {
                list.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }


            list.html("");
          
            for (var i = 0; i < me.entryList.length; i++) {
              
                item = $("<div>", { "class": "vc-list-item", "data-id": me.entryList[i].ID, "data-name": me.entryList[i].Name });
                if (me.entryList[i].Active === false) { item.addClass("inactive"); }
                col1 = $("<div>", { "class": "vc-list-col col1" });
                if (me.specific.isAdmin) {
                    col1.prop("title", "ID:" + me.entryList[i].ID);
                }
                col1.append($("<div>", { "class": "vc-list-col-element w5", "html": me._getListIcon(me.entryList[i].Active, false, "") }));

                tmp = me.entryList[i].Name;
                //do some validation stuff
                infoOk ="";
                infoNotOk = "";
            
                switch (me.eventType) {
                    case 1:
                        infoOk = me.entryList[i].AlarmRule;
                        infoNotOk = me.specific.resources.signalAssignmentMissing_lbl;
                        break;
                    case 2:
                        infoOk = me.entryList[i].AlarmRule;
                        infoNotOk = me.specific.resources.ruleMissing_lbl;
                        break;
                    case 3:
                        infoOk = "";
                        infoNotOk = me.specific.resources.ruleMissing_lbl;
                        break;
                    case 4:
                        infoOk = "";
                        infoNotOk = me.specific.resources.ruleMissing_lbl;
                        break;
                default:
                }
                if (me.entryList[i].AlarmRule.length > 0) {
                    tmp += "<br/><span>" + infoOk + "</span>";
                } else {
                    tmp += "<br/><span class='icon-color-error'>" + infoNotOk + "</span>";
                }
                col1.append($("<div>", { "class": "vc-list-col-element name w40", "html": tmp }));
                col1.append($("<div>", { "class": "vc-list-col-element sub w10", "html": me.entryList[i].User + "<br/>" }));
                col1.append($("<div>", { "class": "vc-list-col-element sub w10", "html": me._getListIcon(me.entryList[i].AlarmOff, true, me.specific.resources.okMessage_lbl) }));
                col1.append($("<div>", { "class": "vc-list-col-element sub w10", "html": me._getListIcon(me.entryList[i].Reminder, true, me.specific.resources.reminder_lbl) }));
                col1.append($("<div>", { "class": "vc-list-col-element sub w20", "html": $("<span>").append(me.entryList[i].QuitType) }));
                item.append(col1);


                col2 = $("<div>", { "class": "vc-list-col col2" });
                //add the del button as col2 and float it right
                col2.append($("<div>", { "class": "btn-del", html: $("<i>", { "class": "fa fa-times vc-list-icon icon-color-error", "title": me.specific.resources.delete_lbl }) }));
                //only active event with valid state
                //for digital alarms not available
                if (me.entryList[i].Active && me.entryList[i].AlarmRule.length > 0 && me.eventType !== 1) {
                    col2.append($("<div>",
                        { "class": "btn-test", html: $("<i>", { "class": "fa fa-paper-plane vc-list-icon ", "title": me.specific.resources.sendTest_lbl }) }));
                    if (me.entryList[i].AlarmState !== '-') {
                    col2.append($("<div>",
                        { "class": "btn-reset-status", html: $("<i>", { "class": "fa fa-eraser vc-list-icon ", "title": me.specific.resources.resetState_lbl }) }));
                }
            }

                item.append(col2);
                item.append($("<div>", { "class": "vc-list-col sub col3", "html": me.entryList[i].AlarmState }));
                list.append(item);
            }

            list.find('.vc-list-item:even').addClass('alt').show();

            //if we show the emax - only 1 entry max is allowed
            //... and we show a simplified list
            if (me.eventType === 4) {
                //if (me.entryList.length >= 1) {
                //    me.fnd("#btn-new").hide();
                //}

                me.fnd(".sub").hide();
            } else {
                me.fnd(".sub").show();
            }


            list.find('.fa').tipTip({defaultPosition:'top'});

            return true;
        } catch (e) {
            me.writeError('_generateList', e); return false;
        }

    },

    _getListIcon: function (on, ok, title) {
        /// <summary>
        /// This function does?? ... guess
        /// </summary>
        var me = this;
        if (on) {
            if (ok) {
                return $("<i>", { "class": "fa-regular fa-bell icon-color-ok", title: title + ' ' + me.specific.resources.activated_lbl });
            } else {
                return $("<i>", { "class": "fa fa-check vc-list-icon icon-color-ok", title: title + ' ' + me.specific.resources.activated_lbl });
            }
          
        } else {
            if (ok) {
                return $("<i>", { "class": "fa-regular fa-bell-slash  icon-color-error", title: title + ' ' + me.specific.resources.deactivated_lbl });
            } else {
                return $("<i>", { "class": "fa fa-power-off vc-list-icon icon-color-error", title: title + ' ' + me.specific.resources.deactivated_lbl });
            }
          
        }
    },


    _del: function (id) {
        /// <summary>
        /// This function deletes the given event id
        /// </summary>
        var me = this;
        try {

            me.fnd("#div-list .vc-list-table").html(me.getLoadingIcon());
            var param = { eventID: id, type: 1 }

            me.updateData(param, function (result) {
                //check response content
                if (result === true) {
                    me._clearSteps();
                    _VCMQ.produce(me.visual, me.vcgid, 'EVENT_CONFIG_DIRTY', "");
                } else {
                    me.showMessage(me.resources.err_saveData, true);
                }
                return true;
            });

        } catch (e) { me.writeError('_del', e); return false; }
        return true;
    },


    _sendTask: function (id, typeid) {
        /// <summary>
        /// This function sends tasks to the server
        /// </summary>
        var me = this;
        try {
            //type 1 = deleting, we don't do that here
            if (typeid === 1) {return false}
            me.fnd("#div-list .vc-list-table").html(me.getLoadingIcon());
            var param = { eventID: id,eventType:me.eventType, type: typeid }
            me.updateData(param, function (result) {
                //check response content
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                } else {
                    //we reload the list after seding the task
                     me._clearSteps();
                }
                return true;
            });

        } catch (e) { me.writeError('_sendTask', e); return false; }
        return true;
    },

    _getConfigStatus: function () {
        /// <summary>
        /// This function fetches the current config status and sets the caption of the config tab
        /// </summary>
        var me = this;
        try {

            var param = {  type: 2 }
            me.getData(param, function (result) {
              
                if (parseInt(result) === 0) {
                    me.fnd("#div-config-selection").html("<i class='fa fa-check icon-color-ok'></i> Config OK");
                } else {
                    me.fnd("#div-config-selection").html("<i class='fa-regular fa-times-circle icon-color-error'></i> Config DIRTY");
                }
            });

        } catch (e) { me.writeError('_getConfigStatus', e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-content,#div-list, #div-config, #div-event-selection, #div-wizard").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});

